<template>
  <div id="perks">
    <div class="perks">
      <h1>2025-26 MEMBERSHIP BENEFITS</h1>
      <p>
        For the 2025-26 season we have expanded our Membership Benefits platform
        to include additional savings and value, access to the team, a new
        Rewards program, and much more.
      </p>
    </div>

    <div class="savings">
      <h1>SAVINGS</h1>
      <p>
        Member Benefits designed to bring you the best possible value across the
        season.
      </p>
      <div class="boxes">
        <div class="box">
          <p>New For 2025-26</p>
          <img src="~images/perks/fastfood.png" alt="" />
          <p>Food and Beverage Credits</p>
        </div>
        <div class="box">
          <p>New For 2025-26</p>
          <img src="~images/perks/car.svg" alt="" />
          <p>$10 Emerald Parking Per Game</p>
        </div>
      </div>
      <div class="items">
        <div class="item">
          <img src="~images/perks/shirt.png" alt="" />
          <p>15% Isles Lab Savings</p>
        </div>
        <div class="item">
          <img src="~images/perks/tickets.png" alt="" />
          <p>Member Rate for Additional Tickets</p>
        </div>
        <!-- <div class="item">
          <img src="~images/perks/chair.png" alt="" />
          <p>Suite Night Savings</p>
        </div>
        <div class="item">
          <img src="~images/perks/rewards.png" alt="" />
          <p>Suite Credits</p>
        </div> -->
        <div class="item">
          <img src="~images/perks/brunch.png" alt="" />
          <p>15% Off Food and Beverage at Belmont Park Village</p>
        </div>
        <div class="item">
          <img src="~images/perks/home.png" alt="" />
          <p>15% Off Plus Special Amenities at Mission Pacific Beach Resort</p>
        </div>
      </div>
    </div>

    <div class="isles">
      <h1>ISLES PREMIER EXPERIENCES FOR ALL MEMBERS</h1>
      <p>
        Member Benefits that provide a greater connection to the team and
        players and are exclusive to Season Ticket Members.
      </p>
      <div class="boxes">
        <div class="box">
          <p>New For 2025-26</p>
          <img src="~images/perks/chat.svg" alt="" />
          <p>State of Hockey Forum with the GM and Head Coach</p>
        </div>
        <div class="box">
          <p>New For 2025-26</p>
          <img src="~images/perks/food.svg" alt="" />
          <p>Fan Fest Summer BBQ with Players</p>
        </div>
        <!-- <div class="box">
          <p>New For 2025-26</p>
          <img src="~images/perks/skate.svg" alt="" />
          <p>Training Camp Access</p>
        </div> -->
        <!-- <div class="box">
          <p>New For 2025-26</p>
          <img src="~images/perks/virtual.svg" alt="" />
          <p>Virtual Chalk Talks with the GM and Hockey Operations</p>
        </div> -->
        <!-- <div class="box">
          <img src="~images/perks/skate.svg" alt="" />
          <p>Season Kick-Off Open Practice at UBS Arena</p>
        </div> -->
        <div class="box">
          <img src="~images/perks/skate.svg" alt="" />
          <p>Access to Exclusive Open Practices</p>
        </div>
        <div class="box">
          <img src="~images/perks/event.svg" alt="" />
          <p>An Evening with the Islanders Player Events</p>
        </div>
      </div>
      <div id="IslesExperiences">
        <h1>ISLES 365 EXPERIENCES</h1>
        <p>
          Member Benefits that grant you access to select unforgettable events
          and experiences throughout the year, with limited capacities to keep
          things more intimate.
        </p>
        <div class="boxes">
          <div class="box">
            <p>New For 2025-26</p>
            <img src="~images/perks/hockey.png" alt="" />
            <p>In-Person Chalk Talks with the GM</p>
          </div>
          <div class="box">
            <p>New For 2025-26</p>
            <img src="~images/perks/locker.png" alt="" />
            <p>Photo Op in Team Locker Room</p>
          </div>
          <div class="box">
            <p>New For 2025-26</p>
            <img src="~images/perks/skate.svg" alt="" />
            <p>Training Camp Practice Access</p>
          </div>
          <div class="box">
            <p>New For 2025-26</p>
            <img src="~images/perks/skate.svg" alt="" />
            <p>Morning Skate Access</p>
          </div>
          <div class="box">
            <img src="~images/perks/tv.png" alt="" />
            <p>Season Ticket Member Watch Parties</p>
          </div>
          <div class="box">
            <img src="~images/perks/handshake.png" alt="" />
            <p>Alumni Meet and Greets</p>
          </div>
          <div class="box">
            <img src="~images/perks/skate.svg" alt="" />
            <p>Member Skate at UBS Arena</p>
          </div>
          <div class="box">
            <img src="~images/perks/paint.png" alt="" />
            <p>Paint the Ice at UBS Arena</p>
          </div>
        </div>
      </div>
    </div>

    <div class="access-rewards">
      <h1>ACCESS AND REWARDS</h1>
      <p>
        Member Benefits that get you to the front of the line and give you even
        more chances to customize your Membership experience.
      </p>

      <div class="boxes">
        <div class="box">
          <p>New For 2025-26</p>
          <img src="~images/perks/phone.png" alt="" />
          <p>Isles In-App Rewards Program</p>
        </div>
        <div class="box">
          <p>New For 2025-26</p>
          <img src="~images/perks/tickets.png" alt="" />
          <p>Bonus Tickets</p>
        </div>
      </div>
      <div class="items">
        <div class="item">
          <img src="~images/perks/tickets.png" alt="" />
          <p>Playoff Access & Individual Ticket Presale</p>
        </div>
        <div class="item">
          <img src="~images/perks/tickets.png" alt="" />
          <p>Ticket Exchange</p>
        </div>
        <div class="item">
          <img src="~images/perks/tickets.png" alt="" />
          <p>UBS Arena Event Presale Access</p>
        </div>
      </div>
    </div>

    <!-- <div id="tenure" class="membership-tenure">
      <h1>MEMBERSHIP TENURE</h1>
      <p>
        We’re proud to honor the loyalty of our Members. We will be celebrating
        key anniversaries and milestones for our longest-tenured Members, as
        well as offering greater rewards based on your Membership Tenure.
      </p>
      <h3>YOUR TENURE LEVEL<br />{{ tenure }}</h3>
      <p>
        Our journey as an NHL franchise goes back to 1972, and we do our best to
        diligently track the tenure of our Members. If you have a question about
        the Tenure Level you see, please
        <a
          href="https://newyorkislanders.formstack.com/forms/nyi_tenure_validation"
          target="_blank"
          >click here</a
        >
        and we'll connect with you to ensure we have it correct. Tenure is
        defined as a continuous New York Islanders membership year over year for
        a consecutive number of years.
      </p>
      <div class="tenures">
        <img src="~images/perks/legends.png" />
        <img src="~images/perks/allstars.png" />
        <img src="~images/perks/veterans.png" />
        <img src="~images/perks/rookie.png" />
      </div>

      <div class="perks-table">
        <div class="header">
          <span>Benefits</span>
          <span>Isles Lab Savings</span>
          <span>Bonus Tickets</span>
          <span>Isles Rewards Points</span>
          <span>Ticket Exchange</span>
          <span>Suite Rental Savings</span>
          <span>Suite Rental Credit</span>
          <span>Playoff Presale for Individual Tickets</span>
        </div>
        <div class="tenure-container">
          <Gallery :initSlide="1" />
        </div>
        <div class="bar">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="41"
            viewBox="0 0 29 41"
            fill="none"
          >
            <path d="M4.5 4L21 20.5L4.5 37" stroke="white" stroke-width="11" />
          </svg>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import Gallery from "@/components/GallerySm/index.vue";

export default {
  name: "Perks",
  components: { Gallery },
  setup() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
#perks {
  background-image: url("~images/perks/bg-perks.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 100px 0;

  @media screen and (max-width: 789px) {
    padding: 100px 0 154px;
  }

  h1 {
    color: #f26925;
    text-align: center;
    font-family: Prompt;
    font-size: 96px;
    font-style: normal;
    font-weight: 900;
    line-height: 88px; /* 91.667% */
    letter-spacing: -0.305px;
    margin-bottom: 29px;

    @media screen and (max-width: 789px) {
      font-size: 48px;
      line-height: 48px;
    }
  }

  p {
    color: #00468b;
    text-align: center;
    font-family: Prompt;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 150% */
    margin-bottom: 0;

    @media screen and (max-width: 789px) {
      font-size: 18px;
      line-height: 24px;
    }
  }

  .perks {
    max-width: 952px;
    width: 95%;
  }

  .savings {
    width: 95%;
    max-width: 960px;
    margin-top: 73px;

    .boxes {
      margin-top: 22px;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      margin-bottom: 93px;
      flex-wrap: wrap;
      gap: 16px;

      @media screen and (max-width: 789px) {
        justify-content: center;
      }

      .box {
        padding: 38px 0 33px;
        border-radius: 8px;
        background: #f26925;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        width: 356px;

        img {
          height: 130px;
          width: auto;
        }

        p {
          color: #fff;
          text-align: center;
          font-family: Prompt;
          font-size: 32px;
          font-style: normal;
          font-weight: 600;
          line-height: 36px; /* 112.5% */
        }
      }
    }

    .items {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 36px;

      .item {
        width: 260px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 27px;

        @media screen and (max-width: 789px) {
          width: 160px;
        }

        img {
          width: 180px;
          height: 180px;
          padding: 21px;
          background-color: #00468b;
          border-radius: 100%;

          @media screen and (max-width: 789px) {
            width: 144px;
            height: 144px;
          }
        }
      }
    }
  }

  .isles {
    width: 95%;
    max-width: 1114px;
    margin-top: 50px;

    p {
      width: 100%;
      max-width: 800px;
      margin: auto;

      &.longer {
        max-width: 960px;
      }
    }

    .boxes {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      gap: 49px;
      margin-top: 40px;
      margin-bottom: 77px;

      .box {
        border-radius: 8px;
        background: #00468b;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        width: 288px;
        padding: 34px 14px;

        p {
          color: #fff;
          text-align: center;
          font-family: Prompt;
          font-size: 24px;
          font-style: normal;
          font-weight: 500;
          line-height: 36px; /* 150% */
          margin-bottom: 0;
        }

        img {
          width: 97px;
          height: 97px;
        }
      }
    }
  }

  .access-rewards {
    width: 95%;
    max-width: 1100px;

    p {
      max-width: 964px;
      margin: auto;
    }

    .boxes {
      margin-top: 22px;
      display: flex;
      justify-content: space-between;
      padding: 0 75px;
      margin-bottom: 93px;
      gap: 28px;
      flex-wrap: wrap;

      @media screen and (max-width: 990px) {
        justify-content: center;
        padding: 0 10px;
      }

      .box {
        padding: 38px 0 33px;
        border-radius: 8px;
        background: #f26925;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        width: 100%;
        max-width: 356px;

        img {
          height: 130px;
          width: auto;
        }

        p {
          color: #fff;
          text-align: center;
          font-family: Prompt;
          font-size: 32px;
          font-style: normal;
          font-weight: 600;
          line-height: 36px; /* 112.5% */
        }
      }
    }

    .items {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 36px;

      .item {
        width: 260px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 27px;

        @media screen and (max-width: 789px) {
          width: 160px;
        }

        img {
          width: 180px;
          height: 180px;
          background-color: #00468b;
          padding: 21px;
          border-radius: 100%;

          @media screen and (max-width: 789px) {
            width: 144px;
            height: 144px;
          }
        }
      }
    }
  }

  .membership-tenure {
    width: 95%;
    max-width: 1158px;
    margin-top: 40px;

    p {
      margin: auto;
      max-width: 928px;
      color: #00468b;
      text-align: center;
      font-family: Prompt;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px; /* 150% */

      a {
        color: #00468b;
      }

      &:nth-of-type(2) {
        color: #00468b;
        font-family: Prompt;
        font-size: 24px;
        font-style: italic;
        font-weight: 400;
        line-height: 36px;

        a {
          color: #00468b !important;
        }
      }
    }

    h3 {
      color: #f26925;
      font-family: Prompt;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 54px;
      text-align: center;
      margin: 40px 0;
    }

    .tenures {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 15px;
      margin-bottom: 33px;
      flex-wrap: wrap;
      gap: 37px;
      img {
        width: 250px;

        @media screen and (max-width: 789px) {
          width: 135px;
        }
      }
    }

    .perks-table {
      width: 100%;
      max-width: 1110px;
      margin: auto;
      display: flex;

      .header {
        display: flex;
        flex-direction: column;
        width: 223px;
        min-width: 155px;

        span {
          color: #fff;
          text-align: center;
          font-family: Prompt;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          border: 1px solid #f26924;
          background: var(--Blue, #00468b);
          padding: 0 25px;
          height: 102px;
          display: flex;
          align-items: center;
          justify-content: center;

          @media screen and (max-width: 789px) {
            padding: 0;
          }

          &:first-of-type {
            background-color: transparent;
            color: var(--Blue, #00468b);
            font-family: Prompt;
            font-size: 30px;
            font-style: normal;
            font-weight: 900;
            line-height: normal;
            text-transform: uppercase;
            border: none;
          }
        }
      }

      .tenure-container {
        width: 100%;
        display: flex;

        .tenure {
          min-width: 100%;
          display: flex;
          flex-direction: column;

          span {
            color: var(--Blue, #00468b);
            text-align: center;
            font-family: Prompt;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            border: 1px solid #f26924;
            background: #d0d2d3;
            height: 101px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:first-of-type {
              font-size: 30px;
              font-weight: 900;
            }
          }
        }
      }
      .bar {
        border: 1px solid var(--NYI-Orange, #f26924);
        background: var(--NYI-Orange, #f26924);
        width: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
#IslesExperiences {
  padding-top: 100px;
}
</style>
